import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import styled from "styled-components";
import { ReactComponent as UserProfileIcon } from "../assets/userProfile.svg";
import { UserProfileFragment$key } from "./__generated__/UserProfileFragment.graphql";

interface UserProfileProps {
  user: UserProfileFragment$key;
}

const UserProfileFragment = graphql`
  fragment UserProfileFragment on UserNode {
    id
    username
    avatar {
      thumbnailUrl
      downloadUrl
    }
  }
`;

export default function UserProfile(props: UserProfileProps) {
  const data = useFragment(UserProfileFragment, props.user);
  const title = `Ingelogd als ${data.username}.`;
  return (
    <IconContainer title={title}>
      {data?.avatar?.thumbnailUrl ? (
        <ProfileImage src={data?.avatar?.thumbnailUrl} />
      ) : data?.avatar?.downloadUrl ? (
        <ProfileImage src={data?.avatar?.downloadUrl} />
      ) : (
        <UserProfileIcon width={18} height={18} />
      )}
    </IconContainer>
  );
}

const IconContainer = styled.div`
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  width: 50px;
  height: 50px;
  border-radius: 50px;
`;

const ProfileImage = styled.img`
  border-radius: 50px;
  width: 50px;
  height: 50px;
  object-fit: cover;
`;
